import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("普通座机号")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("企业座机号")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("手机号码")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Lucy")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "联系我们" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: _ctx.formState,
        name: "basic",
        "label-col": { span: 1 },
        "wrapper-col": { span: 6 },
        autocomplete: "off",
        onFinish: _ctx.onFinish,
        onFinishFailed: _ctx.onFinishFailed
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "客服电话",
            name: "username"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
                name: "radioGroup"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: "1" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: "2" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              _createVNode(_component_a_input, {
                placeholder: "企业座机号",
                value: _ctx.formState.password,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event)),
                style: {"margin":"10px 0 0px 0"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "联系地址",
            name: "username"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formState.password,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.password) = $event)),
                style: {"width":"100%"},
                placeholder: "请选择联系地址"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "lucy" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "详细地址",
            name: "username",
            placeholder: "请选择联系地址"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "请输入详细地址",
                value: _ctx.formState.password,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.password) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            "wrapper-col": { offset: 7, span: 12 },
            style: {"margin-top":"-55px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit",
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit",
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "onFinish", "onFinishFailed"])
    ]),
    _: 1
  }))
}